import { z } from "zod";

export const featureFlagValueSchema = z.union([z.boolean(), z.string()]);

export const defaultFlagsSchema = z.record(z.string(), featureFlagValueSchema);

export type DefaultFlags = z.infer<typeof defaultFlagsSchema>;
